module.exports = __webpack_public_path__ + "static/media/Caminho59.f100288b.svg";